"use client";

import styles from "@/components/sidebar/styles/sidebar-section-item.module.scss";
import Link from "next/link";
import React, { HTMLAttributeAnchorTarget } from "react";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

type SidebarSectionItemProps = {
  title: string;
  href: string;
  hrefTarget?: HTMLAttributeAnchorTarget;
  onClick?: () => void;
  isSelected?: boolean;
  tooltipText?: string;
};

const SidebarSection = ({
  title,
  href,
  hrefTarget,
  onClick,
  isSelected,
  tooltipText,
}: SidebarSectionItemProps) => {
  const { hideModal } = useGlobalModalContext();
  return (
    <Link
      key="main"
      className={`${styles.wrapper} ${isSelected ? styles.selected : ""}`}
      href={href}
      onClick={() => {
        hideModal();
        setTimeout(() => {
          if (onClick) {
            onClick();
          }
        }, 200);
      }}
      target={hrefTarget ?? "_self"}
      data-tooltip-id={"sidebarTooltip"}
      data-tooltip-content={tooltipText}
    >
      <div
        className={`${styles.item} ${isSelected ? styles.selectedText : ""}`}
      >
        {title}
      </div>
    </Link>
  );
};

export default SidebarSection;
